import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import {
  getLoggedUserToken,
  getLoggedUser,
  getRefreshToken,
} from "../../store/auth";
import { styled } from "@mui/material/styles";
import Menu from "../header/Menu";
import Header from "../header/Menu";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    //marginLeft: `-${drawerWidth}px`,
    backgroundColor: "#fafafa",
    marginLeft: 65,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${drawerWidth}px`,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const RequireAuth = () => {
  const [open, setOpen] = useState(true);
  const token = useSelector(getLoggedUserToken);
  //console.log(token);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!token) dispatch(getRefreshToken());
  }, []);
  return token ? (
    <>
      <Main open={open}>
        <Menu open={open} setOpen={setOpen} />
        <DrawerHeader />
        <Outlet />
      </Main>
    </>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
